<template>
	<!-- CHECK IF COMPONENT IS IN USE -->
	<v-card class="ma-2 elevation-3" color="white">
		<v-card-title class="secondary--text">
			Create an Offer
			<v-spacer></v-spacer>

			<v-icon color="secondary" @click="cancelCreateOffer()">mdi-close</v-icon>
		</v-card-title>
		<v-divider />
		<v-card-text>
			<v-flex sm-12>
				<v-select
					color="accent"
					background-color="#f6f6f6"
					:items="professions"
					filled
					dense
					label="Choose type of offer"
					no-data-text="No more professions to select"
					hide-selected
				></v-select>
			</v-flex>

			<!--v-calendar
        ref="calendar"
        :now="today"
        :value="today"
        :events="events"
        color="primary"
        type="month"
      ></v-calendar-->

			<!--MINI CALENDAR -->

			<v-date-picker
				v-model="calendarpickerdate"
				:event-color="date => (date[9] % 2 ? 'primary' : 'green lighten-1')"
				:events="functionEvents"
				:min="new Date().toISOString().substr(0, 10)"
				full-width
				no-title
				range
				header-color="primary"
				color="primary"
				class="elevation-0"
			></v-date-picker>

			<!--DATE PICKERS -->

			<v-row>
				<v-col>
					<!--START DATE  -->

					<v-dialog
						ref="startdatedialog"
						v-model="startdatemodal"
						:value="computedstartDateFormattedMomentjs"
						clearable
						:return-value.sync="startdate"
						persistent
						width="290px"
					>
						<template #activator="{ on }">
							<v-text-field v-model="startdate" label="Start Date:" filled dense readonly v-on="on"></v-text-field>
						</template>
						<v-date-picker v-model="startdate" header-color="primary" color="primary" scrollable>
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="startdatemodal = false">Cancel</v-btn>
							<v-btn text color="primary" @click="$refs.startdatedialog.save(startdate)">OK</v-btn>
						</v-date-picker>
					</v-dialog>
				</v-col>

				<v-col>
					<!--END DATE --->

					<v-dialog ref="enddatedialog" v-model="enddatemodal" :return-value.sync="enddate" persistent width="290px">
						<template #activator="{ on }">
							<v-text-field v-model="enddate" :value="computedendDateFormattedMomentjs" clearable label="End Date:" filled dense readonly v-on="on"></v-text-field>
						</template>
						<v-date-picker v-model="enddate" header-color="primary" color="primary" scrollable>
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="enddatemodal = false">Cancel</v-btn>
							<v-btn text color="primary" @click="$refs.enddatedialog.save(enddate)">OK</v-btn>
						</v-date-picker>
					</v-dialog>
				</v-col>
			</v-row>

			<!--Time Pickers -->

			<p class="font-weight-bold">Time</p>

			<!--START -->
			<v-row>
				<v-col>
					<v-dialog ref="starttimedialog" v-model="startmodal" :return-value.sync="starttime" persistent width="290px">
						<template #activator="{ on }">
							<v-text-field v-model="starttime" label="Start Time:" placeholder="Start Time:" readonly filled dense v-on="on"></v-text-field>
						</template>
						<v-time-picker v-if="startmodal" v-model="starttime" :max="endtime" full-width>
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="startmodal = false">Cancel</v-btn>
							<v-btn text color="primary" @click="$refs.starttimedialog.save(starttime)">OK</v-btn>
						</v-time-picker>
					</v-dialog>
				</v-col>

				<!--END -->
				<v-col>
					<v-dialog ref="endtimedialog" v-model="endmodal" :return-value.sync="endtime" persistent width="290px">
						<template #activator="{ on }">
							<v-text-field v-model="endtime" label="End Time" placeholder="End Time:" readonly filled dense v-on="on"></v-text-field>
						</template>
						<v-time-picker v-if="endmodal" v-model="endtime" :min="starttime" full-width>
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="endmodal = false">Cancel</v-btn>
							<v-btn text color="primary" @click="$refs.endtimedialog.save(endtime)">OK</v-btn>
						</v-time-picker>
					</v-dialog>
				</v-col>
			</v-row>

			<!-- end timepickers -->

			<!--Lunch details -->

			<p class="font-weight-bold">Lunch</p>

			<v-row>
				<v-col>
					<v-btn :color="haslunchbreak ? 'blue' : 'grey lighten-2'" class="ma-2" outlined rounded small @click="toggleLunch">Lunch Break</v-btn>
				</v-col>

				<v-col v-if="haslunchbreak">
					<v-btn :color="haspaidlunch ? 'blue' : 'grey lighten-2'" class="ma-2" outlined rounded small @click="togglePaidLunch">Paid lunch</v-btn>
				</v-col>
			</v-row>

			<v-row v-if="haslunchbreak">
				<v-col>
					<v-btn :color="hashourlunch ? 'blue' : 'grey lighten-2'" class="ma-2" outlined rounded small @click="toggleLunch60">1-hour lunch</v-btn>
				</v-col>
				<v-col>
					<v-btn :color="hashalfhourlunch ? 'blue' : 'grey lighten-2'" class="ma-2" outlined rounded small @click="toggleLunch30">30min lunch</v-btn>
				</v-col>
			</v-row>

			<!-- End Lunch Details -->
		</v-card-text>

		<v-card-actions>
			<v-row>
				<v-col>
					<v-btn elevation="1" block rounded color="white" class="black--text text-center" @click="cancelCreateOffer()">Cancel Offer</v-btn>
				</v-col>

				<v-col>
					<v-btn elevation="1" block rounded color="primary" class="white--text" @click="doCreateOffer()">Create Offer -></v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
	</v-card>
</template>

<script>
import moment from 'moment';
import { bus } from '@/main';
import store from '@/store';
import { getDefaultShiftTimes } from '@/utils/util';

export default {
	name: 'PracticeCreateOffer',
	components: {},
	data: () => ({
		//calendar date picker

		calendarpickerdate: [new Date().toJSON(), new Date().toJSON()],

		currentHover: null,
		allNodes: [],
		focusMonth: null,

		//datepickers

		//startdate: parseISO(new Date().toISOString().substr(0, 10)),
		//enddate: parseISO(new Date().toISOString().substr(0, 10)),
		startdatemodal: false,
		enddatemodal: false,

		//time pickers
		starttime: '09:00',
		endtime: '17:00',

		startmodal: false,
		endmodal: false,

		//lunch
		hashourlunch: false,
		haslunchbreak: false,
		haspaidlunch: false,
		hashalfhourlunch: false,

		//events

		today: '2020-05-17',
		events: [
			{
				name: 'John Doe',
				start: '2020-05-17 09:00',
				end: '2020-05-17 14:00',
			},
			{
				name: 'Jane Doe',
				start: '2020-05-18 12:00',
				end: '2020-05-18 14:00',
			},
			{
				name: 'Edgar September',
				start: '2020-05-19 10:00',
				end: '2020-05-19 14:00',
			},
		],

		professions: ['Proffession 1', 'Proffession 2', 'Proffession 3', 'Proffession 4'],

		languages: store.getters.configs.languages,
	}),
	computed: {
		computedstartDateFormattedMomentjs() {
			return this.startdate ? moment(this.startdate).format('dddd, MMMM Do YYYY') : '';
		},
		computedendDateFormattedMomentjs() {
			return this.enddate ? moment(this.enddate).format('dddd, MMMM Do YYYY') : '';
		},
	},
	created() {
		const { start, end } = getDefaultShiftTimes(this.tenant);
		this.starttime = start;
		this.endtime = end;
	},
	beforeDestroy() {
		// bus.$off('intent:submit-forms');
	},
	methods: {
		//lunch toggles

		toggleLunch() {
			this.haslunchbreak = !this.haslunchbreak;
		},

		toggleLunch30() {
			this.hashourlunch = false;
			this.hashalfhourlunch = !this.hashalfhourlunch;
		},

		toggleLunch60() {
			this.hashalfhourlunch = false;
			this.hashourlunch = !this.hashourlunch;
		},

		togglePaidLunch() {
			this.haspaidlunch = !this.haspaidlunch;
		},
		functionEvents(date) {
			const [, , day] = date.split('-');
			if ([12, 17, 28].includes(parseInt(day, 10))) return true;
			if ([1, 19, 22].includes(parseInt(day, 10))) return ['primary', 'accent'];
			return false;
		},
		cancelCreateOffer() {
			bus.$emit('change-context', 'dashboard-landing-zone');
		},
		doCreateOffer() {
			bus.$emit('change-context', 'practice-to-locum-create-offer');
		},
	},
};
</script>
